import { SubTitlePage } from "../../../components/ui/SubTitlePage";
import { Download } from 'lucide-react';
import { IFileItem } from '../../../types/file';

interface Props {
	files: IFileItem[]
}

export function ListFiles({ files }: Props) {
	return (
		<div className="w-full font-roboto">
			<SubTitlePage title="Arquivos Relacionados" />

			<div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
				{files.map((item, index) => (
					<a
						key={index}
						href={item.url}
						target="_blank"
						rel="noreferrer"
						className="flex items-center gap-4 bg-white dark:bg-surface-dark rounded-2xl p-4 no-underline group transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5 border border-border-default dark:border-border-default-dark hover:border-secondary dark:hover:border-secondary shadow-sm"
					>
						<div className="w-12 h-12 flex items-center justify-center rounded-xl bg-surface-alt dark:bg-surface-dark-alt text-secondary group-hover:bg-secondary group-hover:text-primary transition-all duration-300 shrink-0 shadow-inner">
							<Download size={20} strokeWidth={2.5} />
						</div>
						<div className="flex flex-col min-w-0">
							<span className="text-sm font-bold text-primary dark:text-on-surface-dark group-hover:text-secondary transition-colors line-clamp-2 uppercase tracking-tight leading-snug">
								{item.titulo}
							</span>
							<span className="text-[9px] font-black text-on-surface-subtle/60 dark:text-on-surface-dark-muted/60 uppercase tracking-widest mt-1">
								Clique para baixar • PDF
							</span>
						</div>
					</a>
				))}
			</div>
		</div>
	);
}